import { Product } from 'src/app/models/core/product.model';

/** Precio unitario del producto; un precio faltante cuenta como 0. */
export function getUnitPrice(product: Pick<Product, 'price'>): number {
  return product.price ?? 0;
}

/** Producto con precio real (> 0). Sin precio se muestra "Sin cargo". */
export function hasPrice(product: Pick<Product, 'price'>): boolean {
  return getUnitPrice(product) > 0;
}
